import { onyxGreenColor } from "assets/jss/default/theme";

const caseInfoStyle = theme => ({
  verticalGap: {
    marginTop: theme.spacing(3),
    "&:first-child": {
      marginTop: "0px"
    }
  },
  verticalMiddleGap: {
    marginTop: "15px"
  },
  verticalSmallGap: {
    marginTop: "5px"
  },
  verticalGapDouble: {
    marginTop: "25px"
  },
  marginLeft32: {
    marginLeft: "32px"
  },
  priortyWrapper: {
    width: "99px",
    "& .MuiButton-label": {
      color: "white",
      fontWeight: "500",
      fontSize: "13px"
    },
    "& .MuiButtonBase-root": {
      padding: [[8, 12, "!important"]]
    }
  },
  selectFullWidth: {
    width: "100%"
  },
  recommendedInspectionWrapper: {
    marginTop: "5px",
    "& .MuiSelect-select.MuiSelect-select": {
      backgroundColor: "#f4f4f4",
      padding: "15px",
      fontSize: "14px"
    },
    "& .MuiInput-underline:before": {
      border: "none"
    },
    "& .MuiInputLabel-formControl": {
      color: "#b5b1b1",
      zIndex: "10"
    }
  },
  removePadding: {
    padding: [[0, "!important"]]
  },
  removePaddingLeft: {
    paddingLeft: [[0, "!important"]]
  },
  removePaddingSides: {
    paddingLeft: [[0, "!important"]],
    paddingRight: [[0, "!important"]]
  },
  accordionDetails: {
    padding: [[0, 24, 24, 24, "!important"]]
  },
  inputField: {
    width: "100%",
    "& label.Mui-focused": {
      color: onyxGreenColor
    },
    "& .MuiFilledInput-underline:after": {
      borderBottomColor: onyxGreenColor
    }
  },
  infoIcon: {
    color: onyxGreenColor
  },
  smallFont: {
    fontSize: "14px"
  },
  removeBottomBorder: {
    "& .MuiInput-underline:before": {
      borderBottom: "none"
    }
  },
  longTextField: {
    width: "100%",
    "& .MuiInputBase-input": {
      backgroundColor: "#f4f4f4",
      padding: [[15, "!important"]],
      fontSize: "14px"
    },
    "& .MuiInput-underline:before": {
      border: "none"
    }
  },
  alarmDropWrapper: {
    "& .MuiSelect-select.MuiSelect-select": {
      backgroundColor: "#f4f4f4",
      padding: "15px",
      fontSize: "14px"
    },
    "& .MuiFormControl-root": {
      width: "100%"
    },
    paddingTop: "8px"
  },
  paddingTop8: {
    paddingTop: "8px"
  },
  caseInfoPaddingTwo: {
    padding: [[0, 15]],
    width: "100%"
  },
  caseInfoPaddingOne: {
    padding: [[25, 0]]
  },
  marginButton30: {
    marginBottom: "30px"
  },
  assignedAlarmsButton: {
    backgroundColor: "#f5f5f5",
    borderRadius: "0",
    marginTop: "31px",
    marginBottom: "31px",
    color: "currentColor"
  },
  caseTitle: {
    marginTop: "10px",
    marginLeft: "5px"
  },
  titleSection: {
    marginBottom: "20px"
  },
  estimateLabelWrapper: {
    display: "flex",
    "& .MuiIconButton-root": {
      height: "18px",
      width: "18px",
      padding: "0px",
      marginLeft: "8px"
    }
  }
});

export default caseInfoStyle;
